const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Name",
    dataIndex: "first_name",
    render: defaultRender,
  },
  {
    title: "Email",
    dataIndex: "email",
    render: defaultRender,
  },
  {
    title: "Mobile No",
    dataIndex: "mobile",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "statusText",
    render: defaultRender,
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    render: defaultRender,
  },
  {
    title: "Action",
    dataIndex: "action",
    render: defaultRender,
  },
];

export default columns;
